<mat-form-field floatLabel="always" class="form-item fixed-label icon-field-after w-100">
  @if(showDateAndFormat){
  <mat-label>{{displayLabel | appCountableTimeZone:'MMM dd, yyyy':'UTC'}}</mat-label>
  }@else{
  <mat-label *ngIf="label">{{label}} <span class="fw-semibold" *ngIf="subLabel">{{subLabel}} </span>
    <button *ngIf="showInfo" mat-button class="button-text" matTooltipClass="tooltip-font" #tooltip="matTooltip"
      matTooltipPosition="above" matTooltip="Expiry date is one year from the date of purchase on the invoice no">
      <i class="fa-regular fa-circle-info"></i>
    </button>
    <sup *ngIf="isRequired" class="text-error">*</sup>
  </mat-label>
  }
  <input matInput [matDatepicker]="picker" [formControl]="localDate" (dateChange)="onDateChange($event.value)"
    [max]="maxDate.value" [min]="minDate.value" [placeholder]="placeholderText" [readonly]="isReadOnly"
    oninput="this.value=this.value.replace(/^(\d\d)(\d)$/g,'$1/$2').replace(/^(\d\d\/\d\d)(\d+)$/g,'$1/$2').replace(/[^\d\/]/g,'')">
  <mat-datepicker-toggle [disabled]="isDisabled" matSuffix class="border-start" [for]="picker"></mat-datepicker-toggle>
  <mat-datepicker #picker>
    @if(isMatActions){
    <mat-datepicker-actions>
      <button mat-button mat-stroked-button color="dark" class="button-small flex-1" matDatepickerCancel>Cancel</button>
      <button mat-button mat-flat-button color="primary" class="button-small flex-1" matDatepickerApply>Apply</button>
    </mat-datepicker-actions>
    }
  </mat-datepicker>
</mat-form-field>